import { logError, renderComponent } from '../ReactUtilities';
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import "../../Styles/Dropdown.1.css";
import AccessibleDropDown from '../Components/AccessibleDropDown';

export const getSelectedAccount = () => {
    return document.getElementById("selectedAccount").value;
}
const AccountSelect = () => {
    const [accounts, setAccounts] = useState([]);
    const [accountDictionary, setAccountDictionary] = useState(null);
    const selectedAccnt = getSelectedAccount();
    const [selectedAccount, setSelectedAccount] = useState(selectedAccnt);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const showStateFilter = document.getElementById("showStateFilter")?.value === "true";
    const isStaff = document.getElementById("isStaff")?.value === "true";
    const showStateDropdown = showStateFilter && isStaff;
    const [selectedState, setSelectedState] = useState(null);
    const [states, setStates] = useState([]);
    const [isLoadingAccounts, setIsLoadingAccounts] = useState(false);
    const abortControllerRef = useRef(null);

    const fetchAccountsForState = async (state) => {
        if (abortControllerRef.current) abortControllerRef.current.abort();
        abortControllerRef.current = new AbortController();
        setIsLoadingAccounts(true);
        try {
            const url = state
                ? `/AccountSelect/Accounts?state=${encodeURIComponent(state)}`
                : '/AccountSelect/Accounts';
            const response = await axios.get(url, { signal: abortControllerRef.current.signal });
            if (!response.data) {
                setIsLoggedIn(false);
            } else {
                const json = response.data;
                setAccountDictionary(json);
                setAccounts(Object.entries(json.AccountList));
                setSelectedAccount(json.SelectedAccount);
                setIsLoggedIn(true);
                return json.SelectedAccount;
            }
        } catch (error) {
            if (!axios.isCancel(error)) logError(error, "Error Retrieving Accounts");
        } finally {
            setIsLoadingAccounts(false);
        }

        return null;
    };

    useEffect(() => {
        async function init() {
            if (showStateDropdown) {
                try {
                    const statesResponse = await axios.get('/AccountSelect/States');
                    const stateList = statesResponse.data ?? [];
                    setStates(stateList);
                    const firstState = stateList[0] ?? null;
                    const savedState = sessionStorage.getItem('accountSelectState');
                    const initialState = (savedState && stateList.includes(savedState)) ? savedState : firstState;
                    setSelectedState(initialState);
                    await fetchAccountsForState(initialState);
                } catch (error) {
                    logError(error, "Error Retrieving States");
                    await fetchAccountsForState(null);
                }
            } else {
                await fetchAccountsForState(null);
            }
        }
        init();
    }, []);

    const stateDictionary = Object.fromEntries(states.map(s => [s, { StateName: s }]));
    const stateItems = states.map(s => [s, { StateName: s }]);

    const handleStateChange = async (newState) => {
        const previousAccount = selectedAccount;
        setSelectedState(newState);
        const newSelectedAccount = await fetchAccountsForState(newState);
        if (newSelectedAccount && newSelectedAccount !== previousAccount) {
            sessionStorage.setItem('accountSelectState', newState);
            handleSelectChange(newSelectedAccount);
        }
    };


    const handleSelectChange = async (key) => {
        if (key !== selectedAccount) {
            setSelectedAccount(key);
            let form = document.getElementById("SetAccountForm");
            let selected = document.getElementById("accounts");
            selected.value = key;
            form.submit();
        }
    };

    return (
        <>
            {isLoggedIn &&
                <div className='accountsDropdown'>
                    <div className="accountContainer">
                        <form action="/AccountSelect/SetAccount" id="SetAccountForm">
                            <input type="hidden" name="returnUrl" value={window.location.pathname} />
                            <input type="hidden" name="accounts" id="accounts" value={selectedAccount} />
                            <input type="hidden" id="accountName" value={accountDictionary?.AccountList?.[selectedAccount]?.AccountName ?? ""} />
                            <input type="hidden" id="accountId" value={selectedAccount} />
                            <div className="dropdownsRow">
                                {showStateDropdown && states.length > 0 && (
                                    <div className="stateDropdown">
                                        <AccessibleDropDown
                                            Dictionary={stateDictionary}
                                            Items={stateItems}
                                            SelectedItem={selectedState}
                                            NameField={"StateName"}
                                            ItemName={"State"}
                                            SelectChange={handleStateChange}
                                        />
                                    </div>
                                )}
                                <div className="accountDropdown">
                                    {isLoadingAccounts ? <span>Loading...</span> : accounts.length > 1 ?
                                        <AccessibleDropDown
                                            Dictionary={accountDictionary.AccountList}
                                            Items={accounts}
                                            SelectedItem={selectedAccount}
                                            NameField={"AccountName"}
                                            ItemName={"Account"}
                                            SelectChange={(key) => handleSelectChange(key)}
                                        /> : accountDictionary?.AccountList?.[selectedAccount]?.AccountName ?? ""}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>}
        </>
    );
};

renderComponent(AccountSelect, "accountsDropDown");

export default AccountSelect;